import type { ServiceActivity } from '@waago/ui'

/**
 * Where each activity's request flow lives.
 *
 * French slugs because the URL is part of the product, and this app is
 * French-first (spec §INTERFACES UTILISATEUR). Kept in one place so the home
 * grid, the overflow sheet and any deep link cannot drift apart.
 */
export const ACTIVITY_ROUTE: Record<ServiceActivity, string> = {
  TRANSPORT_PERSON: '/demande/transport',
  DELIVERY: '/demande/livraison',
  EQUIPMENT_RENTAL: '/demande/location',
  DRIVER_HIRE: '/demande/conducteur',
}

/** The reverse mapping, for a screen that has only the slug. */
export const ROUTE_ACTIVITY: Record<string, ServiceActivity> = Object.fromEntries(
  Object.entries(ACTIVITY_ROUTE).map(([activity, route]) => [
    route.split('/').pop() as string,
    activity as ServiceActivity,
  ]),
)
